import { render, staticRenderFns } from "./PropertyPhoto.vue?vue&type=template&id=7dc945b3&scoped=true"
import script from "./PropertyPhoto.vue?vue&type=script&lang=ts"
export * from "./PropertyPhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc945b3",
  null
  
)

export default component.exports